import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/notices-detail.vue'
wx.createPage(MiniProgramPage)